export enum OrderPlacementShipmentType {
    Stock = "Stock",
    Emergency = "Emergency",
    Warranty = "Warranty",
}
